import {
  MAIN_MOUSE_BUTTON,
  MIDDLE_MOUSE_BUTTON,
} from '../../../../constants/mouse'

export function checkIsPanStartAllowed({ event, isPanMode }) {
  return (
    event.button === MIDDLE_MOUSE_BUTTON ||
    (isPanMode && event.button === MAIN_MOUSE_BUTTON)
  )
}
